import CurrencyFilterModel from 'Models/CurrencyFilterModel';

const CurrencyDefaultFieldsModel = {
  STOCK: {
    title: 'Stock',
    component_edit: CurrencyFilterModel.ID_BY_FIELD.INPUT,
    data: {
      _key: 'amount',
      placeholder: 'Stock',
      errorText: 'Stock should be more than Min. purchase amount',
      inputmode: 'numeric',
      textAppendix: {
        mobilePrefix: 'STOCK |',
        prefix: '',
      },
    },
  },

  PRICE_PER_STEP: {
    title: 'Price for', // придумать шо с этим делать
    component_edit: CurrencyFilterModel.ID_BY_FIELD.INPUT,
    data: {
      _key: 'price_per_step',
      errorText: 'Price should be more than %MINIMAL_PRICE%',
      textAppendix: {
        mobilePrefix: 'FOR %STEPSIZE% | $',
        prefix: '$',
      },
      inputmode: 'numeric',
    },
  },

  SKYCOACH_PRICE: {
    title: 'Skycoach price',
    component_edit: CurrencyFilterModel.ID_BY_FIELD.INPUT,
    front_only: true,
    data: {
      _key: 'skycoach_price',
      textAppendix: {
        mobilePrefix: 'SKYCOACH PRICE | $',
        prefix: '$',
      },
      disabled: true,
    },
  },

  MIN_PURCHASE: {
    title: 'Min. purchase',
    component_edit: CurrencyFilterModel.ID_BY_FIELD.INPUT,
    data: {
      _key: 'min_purchase_amount',
      errorText: 'Min. purchase should be more than Step size',
      inputmode: 'numeric',
      textAppendix: {
        mobilePrefix: 'MIN. PURCHASE |',
        prefix: '',
      },
    },
  },
};

CurrencyDefaultFieldsModel.LIST = [
  CurrencyDefaultFieldsModel.STOCK,
  CurrencyDefaultFieldsModel.PRICE_PER_STEP,
  CurrencyDefaultFieldsModel.SKYCOACH_PRICE,
  CurrencyDefaultFieldsModel.MIN_PURCHASE,
];

export default CurrencyDefaultFieldsModel;
